/* tslint:disable */
/* eslint-disable */
/**
 * Analytics Test
 * test for applicants to analytics team
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Settings,
  SettingsUpdatePayloadRequest,
} from '../models';
import {
    SettingsFromJSON,
    SettingsToJSON,
    SettingsUpdatePayloadRequestFromJSON,
    SettingsUpdatePayloadRequestToJSON,
} from '../models';

export interface SettingsRetrieveRequest {
    id: number;
}

export interface SettingsUpdateRequest {
    id: number;
    settingsUpdatePayloadRequest: SettingsUpdatePayloadRequest;
}

/**
 * 
 */
export class SettingsApi extends runtime.BaseAPI {

    /**
     */
    async settingsRetrieveRaw(requestParameters: SettingsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Settings>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling settingsRetrieve.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["ApplicantCode"] = this.configuration.apiKey("ApplicantCode"); // ApplicantAuthentication authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/settings/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SettingsFromJSON(jsonValue));
    }

    /**
     */
    async settingsRetrieve(requestParameters: SettingsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Settings> {
        const response = await this.settingsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates the settings
     */
    async settingsUpdateRaw(requestParameters: SettingsUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Settings>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling settingsUpdate.');
        }

        if (requestParameters.settingsUpdatePayloadRequest === null || requestParameters.settingsUpdatePayloadRequest === undefined) {
            throw new runtime.RequiredError('settingsUpdatePayloadRequest','Required parameter requestParameters.settingsUpdatePayloadRequest was null or undefined when calling settingsUpdate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["ApplicantCode"] = this.configuration.apiKey("ApplicantCode"); // ApplicantAuthentication authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/settings/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SettingsUpdatePayloadRequestToJSON(requestParameters.settingsUpdatePayloadRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SettingsFromJSON(jsonValue));
    }

    /**
     * Updates the settings
     */
    async settingsUpdate(requestParameters: SettingsUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Settings> {
        const response = await this.settingsUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
